import { ApiResponse, AppType } from '@/types';
import { coreApiClient } from './core';
import { Platform } from '@/types/platform';

export const notificationsApi = {
    async updatePushToken(platform: Platform, token: string, appVersion?: string, deviceId?: string, appType?: AppType, deviceModel?: string, apnsEnvironment?: 'production' | 'sandbox'): Promise<ApiResponse<void>> {
        try {
            const response = await coreApiClient.axios.post<ApiResponse<void>>(
                '/api/notifications/token',
                { platform, token, appVersion, deviceId, appType, deviceModel, apnsEnvironment }
            );
            return response.data;
        } catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Failed to update push token'
            };
        }
    },

    async deactivatePushTokens(deviceId: string): Promise<ApiResponse<void>> {
        try {
            const response = await coreApiClient.axios.delete<ApiResponse<void>>(
                '/api/notifications/token',
                { data: { deviceId } }
            );
            return response.data;
        } catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Failed to deactivate push tokens'
            };
        }
    },
};
